import React from 'react';
import { Grid, SpacingName } from '@doveit/lego';
import AgentCard, { AgentCardProps } from '../agent-card/AgentCard';

export interface AgentListProps {
  agents: (AgentCardProps & { id: string })[],
}

const AgentList: React.FC<AgentListProps> = ({
  agents,
}) => (
  <Grid gutter={SpacingName.SMALLER}>
    {agents.map((agent) => (
      <Grid.Unit
        size={{ MD: 1 / 2, LG: 1 / 3 }}
        key={agent.id}
      >
        <AgentCard
          name={agent.name}
          jobTitle={agent.jobTitle}
          picture={agent.picture}
          urlObject={agent.urlObject}
          franchising={agent.franchising}
        />
      </Grid.Unit>
    ))}
  </Grid>
);

export default AgentList;
